export { PdpCashBackAccordion } from './pdp-cash-back-accordion';
